import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

export const ChangeControlGroup = createAction(
  '[Campaign Management: Download Recipients]: Change Control Group',
);

export const ChangeExcluded = createAction(
  '[Campaign Management: Download Recipients]: Change Excluded',
);

export const DownloadRecipients = createAction(
  '[Campaign Management: Download Recipients]: Download',
);

export const DownloadRecipientsSuccess = createAction(
  '[Campaign Management: Download Recipients]: Download Success',
  props<{ res: any }>(),
);

export const DownloadRecipientsFailed = createAction(
  '[Campaign Management: Download Recipients]: Download Failed',
  props<{ error: HttpErrorResponse }>(),
);
